import { render, staticRenderFns } from "./WebOrderDetail.vue?vue&type=template&id=3cd2bf3c&"
import script from "./WebOrderDetail.vue?vue&type=script&lang=js&"
export * from "./WebOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./WebOrderDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports